module.exports = __webpack_public_path__ + "static/media/screenshot5.09626572.jpg";